import type { Policy } from "@p0security/shared/types/policy/types";

import type { ResourceMode } from "../ResourceEditor";

const hasKey = <K extends string>(
  state: unknown,
  key: K
): state is Record<K, unknown> =>
  !!state && typeof state === "object" && key in state;

export const toPrefill = (state: unknown): Partial<Policy> | undefined => {
  if (!hasKey(state, "prefill")) return undefined;
  const { prefill } = state;
  if (!prefill || typeof prefill !== "object") return undefined;
  return prefill as Partial<Policy>;
};

export const toResourceMode = (state: unknown): ResourceMode | undefined => {
  if (!hasKey(state, "resourceMode")) return undefined;
  const { resourceMode } = state;
  if (resourceMode === "any" || resourceMode === "specific")
    return resourceMode;
  return undefined;
};
